<template>
  <div>
    <b-modal  id="apiMessageModal" size="xl" title="API Mesajı" @show="get" hide-footer>

      <div class="row">
        <div class="col-md-12">
          <b-alert show="" variant="info">
            <code>{{notification_url}}</code> adresine yatırım ile ilgili bilgiler gönderildi.
          </b-alert>
        </div>
        <div class="col-md-12">
          <b-form-group label="Sonuç">
            <b-textarea v-model="message" required disabled style="height: 400px;"></b-textarea>
          </b-form-group>
        </div>

      </div>



    </b-modal>
  </div>
</template>

<script>
import depositService from "@/services/depositService";

export default {
  name: "ApiMessage",
  data() {
    return {
      notification_url : '',
      message: ''
    }
  },
  props: ['item'],
  methods: {
    get(){
      depositService.apiResponseDetail({id: this.item})
      .then((res) => {
        if(res.state){
          this.notification_url = res.data.notification_url
          this.message = res.data.api_response
        }else {
          this.$store.dispatch('getConfirmMessage', {show: true, icon: 'error', title: 'Ops!', message: res.message})
        }
      })
    }
  }
}
</script>

<style scoped>

</style>